<div class="container-fluid d-flex align-items-center p-4" style="text-align: center">
    <div class="wizard-progress">
        <ng-container *ngFor="let state of states">
            <div [class]="'step ' + state.abbreviation + ' ' + getClass(state.abbreviation, state.isCurrent)">
                <span class="step-label">{{ state.name }}</span>
                <div class="node"></div>
            </div>
        </ng-container>
    </div>
</div>
